module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7l5FC"))).then(() => module.bundle.root('2KbAe'));